export default "__VITE_ASSET__Cm7ZTLek__"